import React from 'react';
import CheckOrCross from '../../Shared/CheckOrCross';

const vietnameseBasicVoiceFeatures = ({ packages }) =>
  packages.map((pkg) => <CheckOrCross key={pkg.code} isCheck />);

export default vietnameseBasicVoiceFeatures;
